import { Link } from 'react-router-dom';
import { ChevronRightIcon } from '@heroicons/react/20/solid';

interface BreadcrumbItem {
  name: string;
  href?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav className="flex mb-4" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-4">
        {items.map((item, index) => (
          <li key={item.name}>
            <div className="flex items-center">
              {index > 0 && (
                <ChevronRightIcon
                  className="flex-shrink-0 h-4 w-4 text-gray-400"
                  aria-hidden="true"
                />
              )}
              {item.href ? (
                <Link
                  to={item.href}
                  className={`text-sm font-medium ${
                    index > 0 ? 'ml-4' : ''
                  } text-gray-500 hover:text-gray-700`}
                >
                  {item.name}
                </Link>
              ) : (
                <span
                  className={`text-sm font-medium ${
                    index > 0 ? 'ml-4' : ''
                  } text-gray-900`}
                >
                  {item.name}
                </span>
              )}
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
}